<script lang="ts">
  import Skeleton from "svelte-skeleton/Skeleton.svelte";

  export let outsideContainer: boolean = true;
  export let perViewCards: number;

  const skeletonWidth: number = outsideContainer ? 240 : 160;

  const firstRectHeight: number = outsideContainer ? 160 : 130;
  const firstRectWidth: number = outsideContainer ? 70 : 56;
  const firstRectX: number = outsideContainer ? 85 : 45;

  const secondRectWidth: number = outsideContainer ? 150 : 100;
  const secondRectX: number = outsideContainer ? 45 : 25;
  const secondRectY: number = outsideContainer ? 220 : 190;

  const thirdRectWidth: number = outsideContainer ? 200 : 132;
  const thirdRectX: number = outsideContainer ? 20 : 10;
  const thirdRectY: number = outsideContainer ? 250 : 220;

</script>

<style>
  .loading_slides {
    height: 300px;
    overflow-x: hidden;
    justify-content: space-between;
  }

</style>

<div class="loading_slides fizz-flex-row-8" data-testid="product-lines-skeleton">
  {#each Array(perViewCards) as _}
    <div class="fizz-bordered fizz-inset-square-8" style="border-radius: 4px;">
      <Skeleton animate={true} height={270} width={skeletonWidth}>
        <rect
          width={firstRectWidth}
          height={firstRectHeight}
          x={firstRectX}
          y="30"
          rx="12"
          ry="12"
        />
        <rect width={secondRectWidth} height="20" x={secondRectX} y={secondRectY} rx="12" ry="12" />
        <rect width={thirdRectWidth} height="20" x={thirdRectX} y={thirdRectY} rx="12" ry="12" />
      </Skeleton>
    </div>
  {/each}
</div>
